/**
 * Detecta descripciones tipo viñetas y devuelve { items: string[] } o null.
 * Soporta:
 * - Varios renglones, cada uno empezando con "- " o "* "
 * - Un solo párrafo con ítems separados por " - " (ej. "- A. - B. - C")
 */
export function parseDescriptionBullets(text) {
  if (!text || typeof text !== 'string') return null;

  const trimmed = text.trim();
  const lines = trimmed.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);

  const isBulletLine = (l) => /^[-*]\s+/.test(l);
  const stripBullet = (l) => l.replace(/^[-*]\s+/, '').trim();

  if (lines.length > 0 && lines.every(isBulletLine)) {
    return { items: lines.map(stripBullet) };
  }

  // Primera línea título (ej. "Características:") y el resto viñetas
  if (
    lines.length >= 2 &&
    !isBulletLine(lines[0]) &&
    lines.slice(1).every(isBulletLine)
  ) {
    return {
      title: lines[0].replace(/:\s*$/, '').trim(),
      items: lines.slice(1).map(stripBullet),
    };
  }

  if (lines.length === 1) {
    let single = lines[0];
    if (isBulletLine(single)) {
      single = stripBullet(single);
    }
    const parts = single.split(/\s+-\s+/).map((s) => s.trim()).filter(Boolean);
    if (parts.length > 1) {
      return { items: parts };
    }
  }

  return null;
}
